import { gql } from '@apollo/client';

export const QUERY_DIMENSION_VARIABLES = gql`
  query DimensionVariables(
    $dimensionId: Float!
    $municipalityCode: String!
    $language: String
    $municipalityCodes: [String!]
  ) {
    dimensionVariables(
      dimension_id: $dimensionId
      municipality_code: $municipalityCode
      language: $language
      municipality_codes: $municipalityCodes
    ) {
      municipalities {
        name_municipality
        municipality_code
      }
      opportunity_variables {
        id
        name
        description
        display_format
        formatted_value
        source
        value
        period
        unit
        values {
          formatted_value
          municipality_code
          value
        }
        time_series {
          labels
          datasets {
            label
            data
            trend_data
          }
        }
      }
      risk_variables {
        id
        name
        description
        display_format
        formatted_value
        period
        source
        value
        unit
        values {
          formatted_value
          municipality_code
          value
        }
        time_series {
          labels
          datasets {
            label
            municipality_code
            municipality_name
            state
            data
            trend_data
          }
        }
      }
    }
  }
`;

export const QUERY_DIMENSIONS = gql`
  query GetDimensions($pagination: PaginationArgs!, $language: String) {
    dimensions(pagination: $pagination, language: $language) {
      data {
        id
        name
        icon
        bigquery_id
      }
    }
  }
`;
